import React from 'react'
import PropTypes from 'prop-types'

// Components
import Category from './Category'

// Constants
import { CITY, LLD, LATLON } from '../constants'

// Styles
import { primary } from 'hfty-styles/src/colors'

const categorySelectorStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  minHeight: 35,
  backgroundColor: primary(),
  textTransform: 'uppercase',
}

// Exports
export default function CategorySelector({ selected, onSelectCategory, lld }) {
  return (
    <div data-test="CategorySelector" style={categorySelectorStyle}>
      <Category category={CITY} active={selected === CITY} onSelectCategory={onSelectCategory} />
      <Category category={LATLON} active={selected === LATLON} onSelectCategory={onSelectCategory} />
      {lld ? <Category category={LLD} active={selected === LLD} onSelectCategory={onSelectCategory} /> : null}
    </div>
  )
}

CategorySelector.propTypes = {
  selected: PropTypes.oneOf([CITY, LATLON, LLD]).isRequired,
  onSelectCategory: PropTypes.func.isRequired,
  lld: PropTypes.bool,
}
